import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { SEARCH_MODULE_NAMESPACE, SEARCH_AUTOCOMPLETE, SEARCH_REQUEST_BYKEYS_FORCE } from '../../../../store/search';
import { BLOCK_MODULE_NAMESPACE, BLOCK_GET_BLOCKS_AUTOCOMPLETE, BLOCK_GET_BLOCKS } from '../../../../store/block';
import { SearchEntities, AppointmentTypes } from '../../../../common/enums';
import { AGENDA_SET_PARTIAL_PARAMETER, AGENDA_MODULE_NAMESPACE, AGENDA_GET_APPOINTMENTS, AGENDA_SET_LOADER_STATE, AGENDA_LOADERS } from '../../../../store/agenda/agenda-types.store';
import { IAppointmentParameter, IAppointmentListingViewModel } from '../../../../models/appointment';
import * as $ from 'jquery';
import { IBlockParameter } from '../../../../models/block';

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const AgendaStore = namespace(AGENDA_MODULE_NAMESPACE)
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)

@Component({
  components: {
    'agenda-condition-loader' : async () => import('../../loaders/agenda-sidebar-loader/AgendaSidebarLoader.vue')
  }
})
class AgendaSideBarCondition extends Vue {
  _cleatTimeout: any;
  dtExpandActive: boolean[];
  dtCondition: number[];
  dtBlockIds: number[];
  dtICIds: number[];
  dtBlockParameter: IBlockParameter;
  /**
   *
   */
  constructor() {
    super();
    this.dtExpandActive = [false, false, false];
    this.dtBlockIds = [];
    this.dtICIds = [];
    this.dtBlockParameter = { key: '' };
  }

  @AgendaStore.Getter appointmentParameter: IAppointmentParameter;
  @SearchStore.Getter contractors: any[];
  @SearchStore.Getter caretakers: any[];
  @SearchStore.Getter independent_contractors: any[];
  @BlockStore.Getter blocks: any[];
  @AgendaStore.Getter loaders: Map<string,boolean>

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetIndependentContractors: (payload: { entity: SearchEntities[], q: string }) => Promise<any>
  @AgendaStore.Action(AGENDA_GET_APPOINTMENTS)
  storeGetAppointments: () => Promise<IAppointmentListingViewModel>
  @SearchStore.Action(SEARCH_REQUEST_BYKEYS_FORCE)
  storeGetDefaultIndependentContractors: (payload?: { keys: SearchEntities[] }) => void;
  @BlockStore.Action(BLOCK_GET_BLOCKS_AUTOCOMPLETE)
  storeGetBlocksAutocomplete: (param: IBlockParameter) => Promise<any>;
  @BlockStore.Action(BLOCK_GET_BLOCKS)
  storeGetBlocks: (payload: { param: IBlockParameter, merge?: boolean }) => Promise<any>;

  @AgendaStore.Mutation(AGENDA_SET_PARTIAL_PARAMETER)
  storeSetParameter: (param: IAppointmentParameter) => void;
  @AgendaStore.Mutation(AGENDA_SET_LOADER_STATE)
  storeSetLoaderState: (payload: { key: string, value: boolean }) => void

  get lblSetting() {
    return {
      ...require('@/locales/agenda').default,
      ...require('@/locales/ticket').default
    }
  }
  get coResources() {
    console.log('caretakers, contractors, independent_contractors',this.caretakers,this.contractors,this.independent_contractors)
    return [
      { header: this.$t(this.lblSetting.ticketCaretakers) },
      { divider: true },
      ...(this.caretakers || []).map(x => this.mapResources(x).next().value),
      { divider: true },
      { header: this.$t(this.lblSetting.ticketIndependentContractors) },
      { divider: true },
      ...(this.contractors || []).map(x => this.mapResources(x).next().value),
      ...(this.independent_contractors || []).map(x => this.mapResources(x).next().value),
    ]
  }
  get coICOptions() {
    return (this.contractors || []).map(x => ({
      id: x.id, firstname: x.firstname, value: x.id,
      text: `${x.firstname || ''} ${x.firstname || ''}`,
      lastname: x.lastname
    }));
  }
  *mapResources(x) {
    yield {
      id: x.id,
      firstname: x.firstname, value: x.id,
      text: `${x.fullname.trim() || ''}`,
      lastname: x.lastname,
    }
  }
  get coBlockOptions() {
    const bls = this.blocks.map(x => ({
      id: x.id, text: x.name, firstname: x.name,
      lastname: '', value: x.id, ...x
    }));
    return bls;
  }
  get Blocks() {
    return this.appointmentParameter.block;
  }
  set Blocks(value: any) {
    const ids: number[] = value.map(x => x.id || x);
    this.storeSetParameter({ block: ids });
  }
  get IndependentContractors() {
    return this.appointmentParameter.ic;
  }
  set IndependentContractors(value: any) {
    const ids: number[] = value.map(x => x.id || x)
    this.storeSetParameter({ ic: ids });
  }
  get Type(): string {
    return this.appointmentParameter.type;
  }
  set Type(value: string) {

    this.storeSetParameter({ type: value });
  }
  get appointmentTypes() {
    return [
      { value: null, text: this.$t(this.lblSetting.agendaAll) },
      { value: AppointmentTypes.Appointment, text: this.$t(this.lblSetting.agendaAppointment) },
      { value: AppointmentTypes.Event, text: this.$t(this.lblSetting.agendaEvent) }
    ]
  }
  get coLoader(): boolean {
    return this.loaders.get(AGENDA_LOADERS.RESOURCES)
  }

  handleGetIndependentContractors(key: string) {
    return this.storeGetIndependentContractors({
      entity: [
        SearchEntities.Contractor,
        SearchEntities.IndependentContractor,
        SearchEntities.CareTaker
      ],
      q: key
    })
  }
  handleGetBlocks(key: string) {
    return this.storeGetBlocks({ param: { key } })
  }

  handleIndependentContractorsChange(value) {
    this.handleFetchAppointments()
  }


  handleFetchAppointments() {
    clearTimeout(this._cleatTimeout)
    this._cleatTimeout = setTimeout(() => {
      $('#calendar').fullCalendar('removeEvents');
      $('#calendar').fullCalendar('refetchEvents');
    }, 1500);
  }

  handleFetchBlocks() {
    return this.storeGetBlocks({ param: this.dtBlockParameter })
      .then(response=> Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }

  mounted() {
    this.storeSetLoaderState({ key: AGENDA_LOADERS.RESOURCES, value: true })
    this.$nextTick(() => {
      setTimeout(() => {
        Promise.all(
          [
            this.storeGetDefaultIndependentContractors(
              { keys: [SearchEntities.Contractor,SearchEntities.IndependentContractor,SearchEntities.CareTaker] } 
            ),
            this.handleFetchBlocks()
          ]
        )
        .finally(()=> this.storeSetLoaderState({ key: AGENDA_LOADERS.RESOURCES, value: false }))
      }, 500);
    })
  }
}

export default AgendaSideBarCondition;


// WEBPACK FOOTER //
// ./src/containers/agenda/components/agenda-sidebar-condition/index.ts